import {compose, withProps} from 'react-recompose';
import {formatDaysLeft, getRenewalDate} from '../../lib/date-utils';

import {connect} from 'react-redux';
import config from '../../config';
import formatAmount from '../../lib/formatAmount';
import I18n from '../../lib/i18n';
import {customPaymentMeanSelector} from '../../modules/Customer/selectors';
import {isLoadingSelector} from '../../modules/LoadingStatus';
import {
  availableTopUpsSelectorForType,
  selectedTopUpsPriceSelector,
} from '../../modules/TopUps';
import {fetchAvailableTopUps} from '../../modules/TopUps/actions';
import {voucherCurrentVoucherDetailsSelector} from '../../modules/Voucher';
import type {TopUpFlaggedProps as FlaggedProps} from './TopUp';
import TopUp from './TopUp.container';
import {getVisibleNumbers} from './lib';

const mapStateToProps = state => ({
  availableTopUps: availableTopUpsSelectorForType(
    state,
    config.international.BOOSTER,
  ),
  nextRenewalInformation: true,
  paymentMean: customPaymentMeanSelector(state),
  price: selectedTopUpsPriceSelector(state),
  isConfirmationLoading: isLoadingSelector(state, 'topUpConfirmation'),
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
});

const mapDispatchToProps = dispatch => ({
  fetchAvailableTopUps: () =>
    dispatch(fetchAvailableTopUps(config.international.BOOSTER)),
});

const modalTopUpExplanation = (
  price: number,
  paymentMean?: Object,
  walletBalance?: number,
  nextRenewalDate?: number,
  daysLeft?: number,
  currentVoucherDetails?: Object,
) => {
  if (price) {
    const formattedPrice = formatAmount(price);

    if (walletBalance && walletBalance - price >= 0) {
      const textContent = I18n.t(
        currentVoucherDetails
          ? 'modalTopUpExplanation.walletVoucher'
          : 'modalTopUpExplanation.wallet',
        {
          date: getRenewalDate(nextRenewalDate),
          days: formatDaysLeft(daysLeft),
          price: formattedPrice,
        },
      );
      return textContent;
    }

    if (paymentMean) {
      const textContent = I18n.t(
        currentVoucherDetails
          ? 'modalTopUpExplanation.creditCardVoucher'
          : 'modalTopUpExplanation.creditCard',
        {
          cardNumber: getVisibleNumbers(
            paymentMean && paymentMean.functionalId,
          ),
          date: getRenewalDate(nextRenewalDate),
          days: formatDaysLeft(daysLeft),
          price: formatAmount(price),
        },
      );

      return textContent;
    }
  }
};

const footerTopUpExplanation = (
  price: number,
  walletBalance?: number,
  nextRenewalDate?: number,
  daysLeft?: number,
) => {
  let paymentMean = I18n.t('paymentMean.CREDIT_CARD.name').toLowerCase();

  if (walletBalance && walletBalance - price >= 0) {
    paymentMean = I18n.t('paymentMean.WALLET.name');
    return I18n.t('footerTopUpExplanation', {
      date: getRenewalDate(nextRenewalDate),
      days: formatDaysLeft(daysLeft),
      paymentMean,
    });
  }

  return I18n.t('footerTopUpExplanation', {
    date: getRenewalDate(nextRenewalDate),
    days: formatDaysLeft(daysLeft),
    paymentMean,
  });
};

const withNormalTopUpProps = ({
  paymentMean,
  price,
  currentVoucherDetails,
}): FlaggedProps => ({
  confirmButtonText: I18n.t('Dashboard.TopUp.topUpNow'),
  footerTopUpExplanation: (
    walletBalance?: number,
    nextRenewalDate?: number,
    daysLeft?: number,
  ) => footerTopUpExplanation(price, walletBalance, nextRenewalDate, daysLeft),
  modalTopUpExplanation: (
    walletBalance?: number,
    nextRenewalDate?: number,
    daysLeft?: number,
  ) =>
    modalTopUpExplanation?.(
      price,
      paymentMean,
      walletBalance,
      nextRenewalDate,
      daysLeft,
      currentVoucherDetails,
    ),
  orderSummaryTitle: I18n.t('yourTopUp'),
  withZoneValidity: true,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withNormalTopUpProps),
)(TopUp);
